// import InfiniteScroll from "react-infinite-scroll-component";
import Multiselect from 'multiselect-react-dropdown';
import { React, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';

import axios from 'axios';

import { customProductPaths } from '../../providers/TranslatedSlugProvider';
import { useTranslatableSearchParams, useTranslateAndReplaceUrlWhenLanguageChanged } from '../../utils/hooks';
import { getTranslated } from '../../utils/translations';

import { CUSTOM_PRODUCT_IMAGE_SRC } from './custom_product';
import Product_component from './product_component';

// import Accordion from "react-bootstrap/Accordion";
let deleteTimeout;

// const translatableSearchParamsMap = {
//   q: { en: 'q', it: 'q' },
//   fibra: { en: 'fibra', it: 'fibra' },
//   ne: { en: 'ne', it: 'ne' },
//   nm: { en: 'nm', it: 'nm' },
//   utilizzo: { en: 'utilizzo', it: 'utilizzo' },
//   finezza: { en: 'finezza', it: 'finezza' },
// };
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
const Category = (props) => {
  // useTranslateAndReplaceUrlWhenLanguageChanged(props, translatableSearchParamsMap);
  const dataUser = useSelector((state) => state?.auth?.userDataDetail);

  var [results, setResults] = useState([]);
  const [hasCustomProducts, setHasCustomProducts] = useState(false);
  const [somma_colori, setsomma_coloriProducts] = useState({});
  const [filters, setFilters] = useState([]);
  const [nome_articolo, setMome_articolo] = useState([]);
  const [finezza, setFinezza] = useState([]);
  const [nm, setNm] = useState([]);
  const [ne, setNe] = useState([]);
  const [colore, setColore] = useState([]);
  const [areaofuse, setAreaofuse] = useState([]);
  const [tipologia_filato, setTipologiaFilato] = useState([]);
  const [effetti_visivi, setEffettiVisivi] = useState([]);
  const [effetti_tattili, setEffettiTattili] = useState([]);
  const [fibra, setFibra] = useState([]);
  const [certificazioni, setCertificazioni] = useState([]);
  const [caratteristiche, setCaratteristiche] = useState([]);
  const [tecniche_produttive, setTecniche_produttive] = useState([]);
  const [cura_del_capo, setCura_del_capo] = useState([]);
  const [sostenibilita, setSostenibilita] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchParams] = useSearchParams();
  const [active_filters, Setactive_filters] = useState('active');
  const { t, i18n } = useTranslation();
  const userDataDetail = useSelector((state) => state?.auth?.userDataDetail);
  /*if (userDataDetail?.view_credit === false) {
    window.location.href = '/';
  }*/

  const [innerWidth, SetinnerWidth] = useState(window.innerWidth);
  const q = searchParams.get('q');
  const showingSearchResult = typeof q === 'string' || q instanceof String;

  const getAllFilters = () => {
    axios.post('v1/product_list/productfilters').then((response) => {
      setFilters(response?.data?.result?.data);
    });

    setFibra([searchParams.get('fibra')]);
    if (searchParams.get('ne')) setNm([searchParams.get('ne')]);
    if (searchParams.get('nm')) setNe([searchParams.get('nm')]);
    if (searchParams.get('applicazioni')) setAreaofuse([searchParams.get('applicazioni')]);
    setFinezza([searchParams.get('finezza')]);
  };

  const manageFilters = (value, filter, filter_values) => {
    if (!filter_values.includes(value)) {
      filter([...filter_values, value]);
    } else {
      const data = filter_values.filter(function (e) {
        return e !== value;
      });
      filter([...data]);
    }
  };

  useEffect(() => {
    document.getElementById('home_page_class')?.classList.remove('home_page');
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    getAllFilters();
    if (innerWidth <= 767) {
      Setactive_filters('');
    }
  }, []);

  useEffect(() => {
    setResults([]);
    setPage(1);
    setHasMore(true);
    fetchMoreItems(1);
  }, [
    nome_articolo,
    finezza,
    nm,
    ne,
    colore,
    fibra,
    areaofuse,
    tipologia_filato,
    effetti_visivi,
    effetti_tattili,
    certificazioni,
    caratteristiche,
    tecniche_produttive,
    cura_del_capo,
    sostenibilita,
  ]);

  // --- helpers per ordinare NE ---
  const parseNe = (str) => {
    const clean = String(str ?? '').replace(/\s+/g, '');
    const [baseStr, rest] = clean.split('/');
    const base = Number(baseStr);
    if (!rest) return { base, denom: 1, hasMultiplier: false, factors: [], hasSlash: false };

    const parts = rest.split(/[x×]/i).map((p) => Number(p));
    const factors = parts.filter((n) => Number.isFinite(n) && n > 0);
    const denom = factors.length ? factors.reduce((acc, n) => acc * n, 1) : 1;

    return { base, denom, hasMultiplier: /[x×]/i.test(rest), factors, hasSlash: true };
  };

  const compareNe = (a, b) => {
    const A = parseNe(a.value);
    const B = parseNe(b.value);

    if (A.base !== B.base) return A.base - B.base;                 // 60, 70, 80...
    if (A.hasSlash !== B.hasSlash) return A.hasSlash ? 1 : -1;     // 60 prima di 60/1
    if (A.denom !== B.denom) return A.denom - B.denom;             // 60/1, 60/2, 60/3...
    if (A.hasMultiplier !== B.hasMultiplier) return A.hasMultiplier ? 1 : -1; // 60/4 prima di 60/2x2
    if (A.factors.length !== B.factors.length) return A.factors.length - B.factors.length;
    return String(a.value).localeCompare(String(b.value));          // tie-break deterministico
  };
  
  // --- helpers filtro combinato "fibra" (STRICT per AND) ---
  const norm = (s) => String(s ?? '').trim().toLowerCase();

  // Estrae fibre da un nodo (famiglia o articolo)
  // Cerca: campi diretti (fibra/fibre/fiber/fibers/material/materia*), FilterDetail, composition arrays.
  const getFibersFromNode = (node) => {
    if (!node || typeof node !== 'object') return [];

    const out = new Set();

    // 1) Campi diretti comuni
    const direct =
      node.fibra ?? node.fibre ?? node.fibers ?? node.fiber ??
      node.Fibra ?? node.Fibre ?? node.Fibers ?? node.Fiber ??
      node.material ?? node.materials ?? node.materia ?? node.materie;
    if (Array.isArray(direct)) direct.forEach((v) => { if (v) out.add(norm(v)); });
    else if (typeof direct === 'string') direct.split(/[,;|/]+/).forEach((v) => { if (v) out.add(norm(v)); });

    // 2) Chiavi tipo materia_1, materia2, fiber3, material_4...
    Object.keys(node).forEach((k) => {
      const lk = k.toLowerCase();
      if (/^(materia|material|fibra|fibre|fiber|fibers)\d*(_\d+)?$/.test(lk)) {
        const val = node[k];
        if (typeof val === 'string') out.add(norm(val));
        else if (Array.isArray(val)) val.forEach((v) => v && out.add(norm(v)));
      }
    });

    // 3) FilterDetail
    const fd = node.FilterDetail ?? node.details?.FilterDetail ?? [];
    if (Array.isArray(fd)) {
      fd.forEach((entry) => {
        const type = norm(entry?.type);
        if (['fibra', 'fiber', 'fibers', 'fibre', 'materiale', 'material', 'materia'].includes(type)) {
          const val =
            entry?.value ??
            entry?.detail?.value ??
            entry?.detail?.name ??
            entry?.detail?.label ??
            entry?.detail?.title;
          if (Array.isArray(val)) val.forEach((v) => v && out.add(norm(v)));
          else if (val) out.add(norm(val));
        }
      });
    }

    // 4) Composition-like arrays: composition, composizione, comp
    const comp = node.composition ?? node.composizione ?? node.comp;
    if (Array.isArray(comp)) {
      comp.forEach((c) => {
        const v = c?.fiber ?? c?.fibra ?? c?.name ?? c?.material;
        if (v) out.add(norm(v));
      });
    }

    return [...out];
  };

  // Articoli/children di una famiglia (tenta varie chiavi)
  const getFamilyArticles = (family) => {
    const arr =
      family?.articles ??
      family?.articoli ??
      family?.children ??
      family?.products ??
      family?.items ??
      [];
    return Array.isArray(arr) ? arr : [];
  };

  // AND stretto: per più fibre selezionate, accetta solo famiglie con
  // almeno 1 articolo che contiene TUTTE le fibre; se non trovo fibre -> ESCLUDO.
  const familyMatchesFibraAND = (family, selectedFibersNorm) => {
    const articles = getFamilyArticles(family);

    if (articles.length > 0) {
      const hit = articles.some((art) => {
        const f = getFibersFromNode(art);
        return f.length > 0 && selectedFibersNorm.every((s) => f.includes(s));
      });
      if (hit) return true;
      // fallback su fibre della famiglia SOLO se esistono realmente
      const famFibers = getFibersFromNode(family);
      return famFibers.length > 0 && selectedFibersNorm.every((s) => famFibers.includes(s));
    }

    const famFibers = getFibersFromNode(family);
    return famFibers.length > 0 && selectedFibersNorm.every((s) => famFibers.includes(s));
  };
  // --- fine helpers filtro combinato "fibra" ---


  const fetchMoreItems = (page) => {
    clearTimeout(deleteTimeout);

    deleteTimeout = setTimeout(() => {
      axios
        .post(
          `/v1/product_list?page=${page}`,
          {
            nome_articolo: nome_articolo.toString(),
            finezza: finezza.toString(),
            nm: nm.toString(),
            ne: ne.toString(),
            colore: colore.toString(),
            applicazioni: areaofuse.toString(),
            tipologia_filato: tipologia_filato.toString(),
            effetti_visivi: effetti_visivi.toString(),
            effetti_tattili: effetti_tattili.toString(),
            fibra: fibra.toString(),
            biofil: certificazioni.includes('biofil') ? 'si' : '',
            bci: certificazioni.includes('bci') ? 'si' : '',
            gots: certificazioni.includes('gots') ? 'si' : '',
            'oeko-tex': certificazioni.includes('oeko-tex') ? 'si' : '',
            caratteristiche: caratteristiche.toString(),
            tecniche_produttive: tecniche_produttive.toString(),
            cura_del_capo: cura_del_capo.toString(),
            //sostenibilita: sostenibilita.toString(),
            q: q || '',
          },
          {
            headers: {
              Authorization: `Bearer ${dataUser?.token}`,
            },
          }
        )
        .then((response) => {
          setTotal(response?.data?.result?.data?.total);
          if (response?.data?.result?.data?.data?.length == 0) {
            setHasMore(false);
          }
          setPage(page + 1);
          setResults((s) => [...s, ...response?.data?.result?.data?.data]);
          setHasCustomProducts(Boolean(response?.data?.result?.hasCustomProducts));
          setsomma_coloriProducts(response?.data?.result?.somma_colori);
        })
        .catch((error) => console.error(error));
    }, 1500);
  };
  
  const filter_block = (id) => {
    document.getElementById(id).classList.toggle('filter_open');
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  // 0 o 1 fibra: lasciamo i risultati del backend (OR). >1 fibre: AND stretto client-side.
  const visibleResults = useMemo(() => {
    const sel = (fibra || []).filter(Boolean).map(norm);
    if (sel.length <= 1) return results;
    return (results || []).filter((family) => familyMatchesFibraAND(family, sel));
  }, [results, fibra]);

  return (
    <div className="main_content category">
      <div className="category_column">
        <div
          className="filter_mobile"
          onClick={(e) => {
            Setactive_filters(active_filters == 'active' ? '' : 'active');
          }}
        >
          <div className="link">
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                Setactive_filters(active_filters == 'active' ? '' : 'active');
              }}
            >
              {t('filtri')}{' '}
            </a>
          </div>
        </div>
        <div className={' sidebar_section ' + active_filters}>
          <div className="sidebar_title">
            <h3>{t('filtri')}</h3>
            <span
              onClick={(e) => {
                Setactive_filters('');
              }}
              className="close_filter"
            >
              {t('chiudi')}
            </span>
          </div>

          {filters.length == 0 ? (
            <div className="filter_color_loader">
              <div className="loader"></div>
            </div>
          ) : (
            <div className="filter_section">
              <div className="filter_item" id="articolo">
                <div className="title" onClick={() => filter_block('articolo')}>
                  {t('Nome cartella')}
                </div>
                <div className="content size" style={{ marginTop: 15, marginBottom: 15 }}>
                  <Multiselect
                    isObject={false}
                    placeholder={t('seleziona_nome_cartella')}
                    selectedValues={nome_articolo} // Preselected value to persist in dropdown
                    onSelect={(selectedList, selectedItem) => {
                      setMome_articolo([...selectedList]);
                    }} // Function will trigger on select event
                    onRemove={(selectedList, selectedItem) => {
                      setMome_articolo([...selectedList]);
                    }} // Function will trigger on select event
                    options={filters?.nome_articolo?.map((data) => {
                      return data.value[0].toUpperCase() + data.value.substring(1).toLowerCase();
                    })}
                  />
                </div>
              </div>
              <div className="filter_item" id="fibra">
                <div className="title" onClick={() => filter_block('fibra')}>
                  {t('fibra')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    {filters?.fibra
                      ?.sort((a, b) => a.value.localeCompare(b.value)) 
                      .map((data) => (
                        <li
                          className={fibra.includes(data.value) ? 'active' : ''}
                          key={data.value}
                          onClick={() => manageFilters(data.value, setFibra, fibra)}
                        >
                          <span className="name">{data.value}</span>
                          <input type="checkbox" checked={fibra.includes(data.value)} readOnly />
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div className="filter_item" id="tipologia-filato">
                <div className="title" onClick={() => filter_block('tipologia-filato')}>
                  {t('tipologia_filato')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    {filters?.tipologia_filato
                      ?.sort((a, b) => a.value.localeCompare(b.value)) 
                      .map((data) => (
                        <li
                          className={tipologia_filato.includes(data.value) ? 'active' : ''}
                          key={data.value}
                          onClick={() => manageFilters(data.value, setTipologiaFilato, tipologia_filato)}
                        >
                          <a href="javascript:void(0)">{data.value}</a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div className="filter_item" id="finezza">
                <div className="title" onClick={() => filter_block('finezza')}>
                  {t('finezza')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    {filters?.finezza?.map((data) => (
                      <li
                        className={finezza.includes(data.value) ? 'active' : ''}
                        key={data.value}
                        onClick={() => manageFilters(data.value, setFinezza, finezza)}
                      >
                        <a href="javascript:void(0)">{data.value}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="filter_item" id="nm">
                <div className="title" onClick={() => filter_block('nm')}>
                  {t('nm')}
                </div>
                <div className="content size">
                <ul className="scroll_fix scroll_fix_with_scroll">
                  {[...filters?.nm || []]
                    .filter((data) => data.value !== '1')
                    .sort((a, b) => {
                      // Funzione per convertire frazione in numeratore e denominatore
                      const parseFraction = (str) => {
                        if (str.includes('/')) {
                          const [numerator, denominator] = str.split('/').map(Number);
                          return { numerator, denominator };
                        }
                        return { numerator: parseFloat(str), denominator: 1 };
                      };

                      const valA = parseFraction(a.value);
                      const valB = parseFraction(b.value);

                      const isIntA = valA.denominator === 1;
                      const isIntB = valB.denominator === 1;

                      if (isIntA && !isIntB) return -1;
                      if (!isIntA && isIntB) return 1;

                      // Se entrambi sono interi, ordinarli numericamente
                      if (isIntA && isIntB) {
                        return valA.numerator - valB.numerator;
                      }

                      // Se entrambi sono frazioni, ordinarle per denominatore poi per numeratore
                      if (valA.denominator === valB.denominator) {
                        return valA.numerator - valB.numerator;
                      }

                      return valA.denominator - valB.denominator;
                    })
                    .map((data) => (
                      <li
                        className={nm.includes(data.value) ? "active" : ""}
                        key={data.value}
                        onClick={() => manageFilters(data.value, setNm, nm)}
                      >
                        <a href="javascript:void(0)">{data.value}</a>
                      </li>
                    ))
                  }
                </ul>
                </div>
              </div>
              <div className="filter_item" id="Ne">
                <div className="title" onClick={() => filter_block('Ne')}>
                  {t('ne')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix scroll_fix_with_scroll">
                    {[...(filters?.ne || [])]
                      .filter((data) => data.value !== 'NA' && data.value !== 'N/A' && data.value !== '2')
                      .sort(compareNe)
                      .map((data) => (
                        <li
                          className={ne.includes(data.value) ? 'active' : ''}
                          key={data.value}
                          onClick={() => manageFilters(data.value, setNe, ne)}
                        >
                          <a href="javascript:void(0)">{data.value}</a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div className="filter_item" id="colore">
                <div className="title" onClick={() => filter_block('colore')}>
                  {t('color')}
                </div>
                <div className="content color">
                  <ul className="scroll_fix">
                    {filters?.colore?.map((data) => (
                      <li
                        className={colore.includes(data.value) ? 'active' : ''}
                        key={data.value}
                        onClick={() => manageFilters(data.value, setColore, colore)}
                      >
                        <a href="#">
                          <div className="item_color">
                            <span className="color" style={{ backgroundColor: data.hex, border: 'none' }} />
                            <span className="color_name">
                              {data.name[0].toUpperCase() + data.name.substring(1).toLowerCase()}
                            </span>
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="filter_item" id="applicazioni">
                <div className="title" onClick={() => filter_block('applicazioni')}>
                  {t('applicazioni')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    
                    {filters?.applicazioni?.map((data) => (
                      <li
                        className={areaofuse.includes(data.value) ? 'active' : ''}
                        key={data.value}
                        onClick={() => manageFilters(data.value, setAreaofuse, areaofuse)}
                      >
                        <a href="javascript:void(0)">{data.value}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="filter_item" id="effetti-visivi">
                <div className="title" onClick={() => filter_block('effetti-visivi')}>
                  {t('effetti_visivi')}
                </div>
                <div className="content size">
                  <Multiselect
                    isObject={false}
                    placeholder={t('seleziona_effetti_visivi')}
                    selectedValues={effetti_visivi} 
                    onSelect={(selectedList, selectedItem) => {
                      setEffettiVisivi([...selectedList]);
                    }} 
                    onRemove={(selectedList, selectedItem) => {
                      setEffettiVisivi([...selectedList]);
                    }} 
                    options={filters?.effetti_visivi
                      ?.map((data) => capitalizeFirstLetter(data.value))
                      ?.sort((a, b) => a.localeCompare(b))}
                  />
                </div>
              </div>
              <div className="filter_item" id="effetti-tattili">
                <div className="title" onClick={() => filter_block('effetti-tattili')}>
                  {t('effetti_tattili')}
                </div>
                <div className="content size">
                  {<Multiselect
                    isObject={false}
                    placeholder={t('seleziona_effetti_tattili')}
                    selectedValues={effetti_tattili}
                    onSelect={(selectedList, selectedItem) => {
                      setEffettiTattili([...selectedList]);
                    }} 
                    onRemove={(selectedList, selectedItem) => {
                      setEffettiTattili([...selectedList]);
                    }} 
                    options={filters?.effetti_tattili
                      ?.map((data) => capitalizeFirstLetter(data.value))
                      ?.sort((a, b) => a.localeCompare(b))
                      .filter(value => value !== undefined && value !== null && value !== '')}
                  />}
                </div>
              </div>
              <div className="filter_item" id="certificazioni">
                <div className="title" onClick={() => filter_block('certificazioni')}>
                  {t('Certificazioni e impegni')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    {filters?.certificazioni?.map((data) => (
                      <li
                        className={certificazioni.includes(data.value) ? 'active' : ''}
                        key={data.name}
                        onClick={() => manageFilters(data.value, setCertificazioni, certificazioni)}
                      >
                        <a className="capitalize" href="javascript:void(0)">
                          {data.value}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/*<div className="filter_item" id="produttive">
                <div className="title" onClick={() => filter_block('produttive')}>
                  {t('tecniche_produttive')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    {filters?.tecniche_produttive?.map((data) => (
                      <li
                        className={tecniche_produttive.includes(data.value) ? 'active' : ''}
                        key={data.value}
                        onClick={() => manageFilters(data.value, setTecniche_produttive, tecniche_produttive)}
                      >
                        <a href="javascript:void(0)">{data.value}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>*/}
              <div class="filter_item" id="Cura_del_capo">
                <div class="title" onClick={() => filter_block('Cura_del_capo')}>
                  {t('cura_del_capo_consigliata')}
                </div>
                <div class="content head_care size">
                  <ul className="scroll_fix ul_modification">
                    {filters?.cura_del_capo?.map((data, idx) => (
                      <>
                        <li
                          className={`button_cura_del_corpo ${cura_del_capo.includes(data.value) ? 'active' : ''}`}
                          key={data.value}
                          onClick={() => manageFilters(data.value, setCura_del_capo, cura_del_capo)}
                        >
                          <div class="item_care">
                            <span class="care_image" tabIndex={0} aria-describedby={`tip-cdc-${idx}`}>
                              <img
                                src={data?.icon_cura_del_capo_full}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src = '/images/artic_06.jpg';
                                }}
                                alt={data?.value}
                              />
                              <span id={`tip-cdc-${idx}`} role="tooltip" className="care_tooltip">
                                {data?.value}
                              </span>
                            </span>
                          </div>
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
              </div>

              {/*<div className="filter_item" id="Sostenibilità">
                <div className="title" onClick={() => filter_block('Sostenibilità')}>
                  {t('sostenibilita')}
                </div>
                <div className="content size">
                  <ul className="scroll_fix">
                    {filters?.sostenibilita?.map((data) => (
                      <li
                        className={sostenibilita.includes(data.value) ? 'active' : ''}
                        key={data.value}
                        onClick={() => manageFilters(data.value, setSostenibilita, sostenibilita)}
                      >
                        <a href="javascript:void(0)">{data.value}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>*/}
            </div>
          )}

          <div className="filter_mobile sidebar">
            <div className="link">
              <a href="#">{t('mostra_99_articoli')}</a>
            </div>
          </div>
        </div>
        {isLoading ? (
          <>
            <div className="loader_wrapper">
              <div class="loader"></div>
            </div>
          </>
        ) : (
          <div className="product_section">
            <div className="product_top">
              <div className="title_section">
                <h2> {t('configura_il_tuo_filato')}</h2>
                {showingSearchResult ? (
                  <h1 className="mobile_search">
                    {t('risulati_di_ricerca_per')}: <b>“{q}”</b>
                  </h1>
                ) : (
                  ''
                )}
              </div>
              {true || showingSearchResult ? (
                ''
              ) : (
                <div className="toolbar_section d-none">
                  <p>{t('visualizza_per')}</p>
                  <div className="sorter_dropdown">
                    <a href="javascript:void(0);" className="sorter_current active">
                      {t('collezione')}
                    </a>
                    <div className="sorter_options">
                      <ul className="scroll_fix">
                        <li>
                          <a href="javascript:void(0);" value={10}>
                            {t('collezione')}
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);" value={25}>
                            {t('finezza')}
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);" value={50}>
                            {t('color')}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <InfiniteScroll
              pageStart={0}
              limit={15}
              loadMore={() => fetchMoreItems(page)}
              className="row"
              dataLength={100}
              // initialScrollY={0}
              // pageStart={1}
              // limit={50}
              // threshold={3000}
              hasMore={hasMore}
              loader={
                <>
                  <div className="infinite_loader">
                    <div class="loader"></div>
                  </div>
                </>
              }

              // endMessage={<>Done</>}
            >
              <div className="product_items">
                {hasCustomProducts && !showingSearchResult ? (
                  <Link to={getTranslated(i18n, customProductPaths, { en: 'en', it: 'it' }, 'it')}>
                    <div className="product_item">
                      <img src={CUSTOM_PRODUCT_IMAGE_SRC} alt="Immagine" />
                      <div className="product_data">
                        <span className="tag">{t('Prodotti personalizzati')}</span>
                      </div>
                    </div>
                  </Link>
                ) : null}
                {visibleResults?.map((result) => (
                  <Product_component key={result.id} data={result} somma_colori_data={somma_colori} />
                ))}
              </div>
            </InfiniteScroll>
          </div>
        )}
      </div>
    </div>
  );
};

export default Category;